
const dimensionInfo = {
    external:"External elevation with all applicable outer dimension",
    dimension:"Dimension between closest unit and wall",
    hinge_handle:"Hinge and handle orientation in elevation",
    skirting_1:"Skirting color and height",
    skirting_2:"Skirting 100/120mm ht will be available as different module",
    carcass:"Carcass depth of all module type Ex-Base/Wall/Tall/Tambour/loft"
}

const materualInfo = {
    hinge:"Hinge and handle orientation is mandate", 
    module:"Module code/color code/Visible code is mandate", 
    visible:"Visible side additional panel to be with module number and color code", 
    shutter:"Shutter core for all module types Ex:Base/Wall/Tall..etc",
    outerStructure:"Outer structure and internal structure will be different colour",
    skirting:"Skirting colour will be matching to the outer structure",
    color_code:"Color name/code and mapping of colors to code mentioned in elevation"
}

const internalInfo = {
    outerStructure:"Outer stucture will be in 25mm thickness, internal structure will be in 18mm thickness",
    accessorycode:"Accessory code for all accessory",
    accessoryimage:"Image of accessory and mapping to accessory code in elevation"
}

const overviewInfo={
    plan:"Plan with wall orientation",
    measure:"No need of measurments",
    kitchen:"3D Views of the Kitchen",
    keyplan:"Key Plan"
}

export const sidebarInfo = {
    HOMELANE:{
    OVERVIEW: {
        "kitchen": [overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan],
        "livingroom":[overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan],
        "bedroom": [overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan],
        "bathroom": [overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan]
    },
    PLAN: {
        "kitchen": {
            "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
            "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
        },
        "livingroom":{
            "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
            "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
        },
        "bedroom":{
            "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
            "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
        },
        "bathroom":{
            "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
            "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
        }
    },
    DIMENSION: {
        "floor standing":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "suspended":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "hinged": {
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "sliding-overlay": {
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "sliding-inset": {
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "slide and fold":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "wall mirror":{
            "Elevation":[dimensionInfo.external,dimensionInfo.dimension],
        },
        "bedside table":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "book shelf":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "chest of drawer":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "window seating":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "partition system":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "wall decor":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "wall panelling":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "bar unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "room divider":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "crockery unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "entertainment unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "foyer unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "pooja unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "study unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "floor standing utility unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "suspended vanity unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        },
        "floor standing vanity unit":{
            "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
            "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
        }
    },
    MATERIAL: {
        "floor standing":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "suspended": {
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "hinged": {
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "sliding-overlay":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "sliding-inset": {
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "slide and fold":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "wall mirror":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "bedside table":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "book shelf":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "chest of drawer":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "window seating":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "partition system":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "wall decor":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "wall panelling":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "bar unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "room divider":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },//
        "crockery unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "entertainment unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "foyer unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "pooja unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "study unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "floor standing utility unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "suspended vanity unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        },
        "floor standing vanity unit":{
            "Elevation":[materualInfo.module,materualInfo.shutter,materualInfo.color_code]
        }
    },
    INTERNAL: {
        "sliding-inset": {
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "floor standing": {
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "suspended":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "hinged": {
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "sliding-overlay": {
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "slide and fold":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "wall mirror":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "bedside table":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "book shelf":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "chest of drawer":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "window seating":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "partition system":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "wall decor":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "wall panelling":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "bar unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "room divider":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "crockery unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "entertainment unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "foyer unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "pooja unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "study unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "floor standing utility unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "suspended vanity unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        },
        "floor standing vanity unit":{
            "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
        }

    }
    
    },
    DOOWUP:{
        OVERVIEW: {
            "kitchen": [overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan],
            "livingroom":[overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan],
            "bedroom": [overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan],
            "bathroom": [overviewInfo.plan,overviewInfo.measure,overviewInfo.kitchen,overviewInfo.keyplan]
        },
        PLAN: {
            "kitchen": {
                "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
                "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
            },
            "livingroom":{
                "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
                "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
            },
            "bedroom":{
                "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
                "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
            },
            "bathroom":{
                "Elevation":["Plan with outer dimension of overall Room","Civil structure depth to be specified manually Ex- Column/Beam/raise platform ..etc"],
                "Specification":["Carcass core as per defined in 3D","Handle Design code and size for all module type Ex-Base/Wall/Tall..etc"]
            }
        },
        DIMENSION: {
            "floor standing":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "suspended":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "hinged": {
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "sliding-overlay": {
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "sliding-inset": {
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "slide and fold":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "wall mirror":{
                "Elevation":[dimensionInfo.external,dimensionInfo.dimension],
            },
            "bedside table":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "book shelf":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "chest of drawer":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "window seating":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "partition system":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "wall decor":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "wall panelling":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "bar unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "room divider":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "crockery unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "entertainment unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "foyer unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "pooja unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "study unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "floor standing utility unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "suspended vanity unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            },
            "floor standing vanity unit":{
                "Elevation":[dimensionInfo.external,dimensionInfo.hinge_handle,dimensionInfo.dimension],
                "Specification":[dimensionInfo.skirting_1,dimensionInfo.carcass]
            }
        },
        MATERIAL: {
            "floor standing":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "suspended": {
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "hinged": {
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "sliding-overlay":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "sliding-inset": {
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "slide and fold":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "wall mirror":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "bedside table":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "book shelf":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "chest of drawer":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "window seating":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "partition system":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "wall decor":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "wall panelling":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "bar unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "room divider":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },//
            "crockery unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "entertainment unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "foyer unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "pooja unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "study unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "floor standing utility unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "suspended vanity unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            },
            "floor standing vanity unit":{
                "Elevation":[materualInfo.module],
                "Specification":[materualInfo.shutter,materualInfo.color_code]
            }
        },
        INTERNAL: {
            "sliding-inset": {
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "floor standing": {
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "suspended":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "hinged": {
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "sliding-overlay": {
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "slide and fold":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "wall mirror":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "bedside table":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "book shelf":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "chest of drawer":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "window seating":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "partition system":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "wall decor":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "wall panelling":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "bar unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "room divider":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "crockery unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "entertainment unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "foyer unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "pooja unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "study unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "floor standing utility unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "suspended vanity unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            },
            "floor standing vanity unit":{
                "Elevation":[internalInfo.accessorycode,internalInfo.accessoryimage]
            }
    
        }
    }
}



